import React, { useContext, useEffect, useState } from "react";
import { Avatar, Divider, Grid, Menu, Typography } from "@mui/material";
import "./NotificationsModal.css";
import TimeAgo from "javascript-time-ago";
import {
  useGetNotificationsMutation,
  useMarkAllSeenMutation,
  useMarkSeenMutation,
} from "../../features/notification/notificationApiSlice";
import { SocketContext } from "../../context/SocketProvider";
import classNames from "classnames";
// import useNotifications from "../../hooks/useNotifications";

const BoldText = ({ children }) => {
  return <span className="bold-600">{children}</span>;
};

const NotificationCard = ({ color, children, avatar, time, onClick }) => {
  return (
    <Grid
      className={`p-3 d-flex align-items-center notification-card`}
      onClick={onClick}
    >
      {avatar && (
        <Avatar
          className="notification-avatar"
          style={{
            backgroundColor: color,
          }}
        >
          {avatar}
        </Avatar>
      )}
      <Grid className="px-2 text-color font-14">
        {children}
        <Typography className="secondary-text-color font-12">{time}</Typography>
      </Grid>
    </Grid>
  );
};

const NotificationsModal = ({ anchorEl, open, onClose }) => {
  const [markSeen] = useMarkSeenMutation();
  const [markAllSeen] = useMarkAllSeenMutation();
  const { notifications, setNotifications } = useContext(SocketContext);
  // const { notifications, updateNotificationApi } = useNotifications();
  // Create formatter (English).
  const timeAgo = new TimeAgo("en-US");

  const handleNotificationClick = async (payload) => {
    await markSeen({ ...payload });
    setNotifications((prev) =>
      prev.map((n) => (n.id === payload.id ? { ...n, isSeen: true } : n))
    );
    switch (payload.type) {
      case "MESSAGE_MENTION":
        // Navigate("/messagecenter");
        break;

      default:
        break;
    }
  };

  const notificationData = notifications?.filter((f) => !f.isSeen);

  const handleClear = async () => {
    await markAllSeen({ notificationIds: notificationData.map((n) => n.id) });
    setNotifications((prev) => prev.map((n) => ({ ...n, isSeen: true })));
  };

  return (
    <Menu id="menu-appbar" anchorEl={anchorEl} open={open} onClose={onClose}>
      <Grid style={{ width: 500 }}>
        <Grid>
          <Typography style={{ fontSize: 26 }} className="px-3 py-1 bold-600">
            Notifications
          </Typography>
        </Grid>
        <Divider />
        <div className="notifications-div">
          {notificationData.length ? (
            notificationData.map((notification, idx) => {
              if (notification.isSeen) {
                return null;
              }
              return (
                <div key={idx}>
                  <NotificationCard
                    avatar={"ME"}
                    color={"#FBD5E2"}
                    time={timeAgo.format(new Date(notification.createdAt))}
                    onClick={() => handleNotificationClick(notification)}
                  >
                    {" "}
                    <Typography>{notification.content?.heading}</Typography>
                    <Typography>{notification.content?.subheading}</Typography>
                  </NotificationCard>
                  <Divider />
                </div>
              );
            })
          ) : (
            <div className="d-flex justify-content-center py-3">
              <span>No Notifications</span>
            </div>
          )}
        </div>
        <Divider />
        {notificationData.length > 0 && (
          <div className="px-3 pt-2 flex justify-end">
            <button
              className={classNames(
                "text-sm m-0 py-1 px-2 bg-white font-semibold rounded-lg flex items-center gap-1 ",
                "text-primaryblue border-[1px] border-primaryblue"
              )}
              onClick={handleClear}
            >
              Clear All
            </button>
          </div>
        )}
      </Grid>
    </Menu>
  );
};

export default NotificationsModal;
